import { CellProps } from "react-table";
import DateCell from "src/components/tables/cells/DateCell";
import TextCell from "src/components/tables/cells/TextCell";
import ActionsCell from "./ActionsCell";
import { InventoryType } from "./inventory-types";

const useInventoryTableColumns = ({
  onDelete,
}: {
  onDelete: (id: number) => void;
}) => {
  return [
    {
      Header: "Vendor name",
      accessor: "vendorName",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Product name",
      accessor: "name",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Quantity",
      accessor: "stock",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Price (₹)",
      accessor: "price",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Received Date",
      accessor: "createdAt",
      className: "min-w-[150px]",
      Cell: DateCell,
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<InventoryType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useInventoryTableColumns;
